document.onload = function() {
  let articles = document.querySelectorAll('section.timeline article.timeline-element');
  let firstArticle = articles[0];
  let lastArticle = articles[articles.length - 1];

  firstArticle.classList.add('article-visible');
  
  window.addEventListener('scroll', function() {
      let scrolledToTop = (window.scrollY === 0);
      let scrolledToBottom = (window.innerHeight + window.scrollY) >= document.body.offsetHeight;

      for (let i = 0; i < articles.length; i++) {
          if (i === 0 && scrolledToTop) {
              firstArticle.classList.add('article-visible');
              continue;
          }

          if (isElementPartiallyVisible(articles[i], 0.2)) {
              articles[i].classList.add('article-visible');
          } else if (articles[i] !== lastArticle) {
              articles[i].classList.remove('article-visible');
          }
      }

      if (scrolledToBottom || isElementInView(lastArticle)) {
          lastArticle.classList.add('article-visible');
      }
  });

  // Función para verificar si un elemento está parcialmente visible
  function isElementPartiallyVisible(element, visibilityThreshold) {
      const rect = element.getBoundingClientRect();
      const windowHeight = (window.innerHeight || document.documentElement.clientHeight);

      // Calculo de la visibilidad del elemento
      const elementHeight = rect.bottom - rect.top;
      const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
      const visibilityRatio = visibleHeight / elementHeight;

      return visibilityRatio >= visibilityThreshold;
  }

  function isElementInView(element) {
      const rect = element.getBoundingClientRect();
      return rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
  }

  document.getElementById('hamburger-menu').addEventListener('click', function() {
    const menu = document.getElementById('menu-mobile');
    menu.classList.toggle('menu-mobile-visible');
  });

  document.querySelector('.menu-mobile-close').addEventListener('click', function() {
    const menu = document.getElementById('menu-mobile');
    menu.classList.remove('menu-mobile-visible');
  });

}();

